// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2HQna","requiredAsterisk":"Info_requiredAsterisk__1Ex0Y"};